import { Api } from '@axiom/ui';
import type { Candidate, CandidateTag } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class TalentTagsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readCandidateTags(candidateId: Candidate['id']) {
    return super.read<{ data: CandidateTag[] }>({
      endpoint: `/candidates/${candidateId}/tags`,
      method: 'GET',
    });
  }

  async refreshCandidateTags(candidateId: Candidate['id']) {
    return super.invalidate(`/candidates/${candidateId}/tags`);
  }

  async updateCandidateTags({
    candidateId,
    body,
  }: {
    candidateId: Candidate['id'];
    body: Array<CandidateTag['id']>;
  }) {
    return super.write<{ data: CandidateTag[] }>({
      endpoint: `/candidates/${candidateId}/tags`,
      body,
      method: 'PUT',
    });
  }
}

export const TalentTagsApi = new TalentTagsApiClass();
